import React, {Component} from "react";

class RewardDashboard extends Component{
    render(){
        return(
            <React.Fragment>
                <div className="breadcrumb-area">
                    <h3>STAKE YOUR LIGHT-BNB LP TOKENS</h3>
                    <p className="sec-txt">You can now stake your LIGHT-BNB LP tokens and earn BNB.</p>
                    <div className="rounds-flex reward-dash-widget">
                        <div>
                            <h1 className="prim-txt">149.74 %</h1>
                            <h5 className="sec-txt">CURRENT APR</h5>
                        </div>
                        <div>
                            <h1 className="prim-txt">$3,657,592.22</h1>
                            <h5 className="sec-txt">TVL in staking pool</h5>
                        </div>
                        <div>
                            <h1 className="prim-txt">-</h1>
                            <h5 className="sec-txt">YOUR AVERAGE REWARDS PER DAY</h5>
                        </div>
                        
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default RewardDashboard;